export const APP_VERSION = "2.0.1";
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || "dev";
